module.exports = __webpack_public_path__ + "static/media/GR8Conf.9ae1e713.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GR8Conf.svg
// module id = 437
// module chunks = 0